// src/hooks/useGeolocation.js
import { useState, useCallback } from 'react';

export const useGeolocation = () => {
    const [position, setPosition] = useState({ latitude: null, longitude: null });
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const getLocation = useCallback(() => {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                const err = 'La géolocalisation n\'est pas supportée par ce navigateur';
                setError(err);
                reject(err);
                return;
            }

            setLoading(true);
            setError(null);

            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    const coords = {
                        latitude: pos.coords.latitude,
                        longitude: pos.coords.longitude
                    };
                    setPosition(coords);
                    setLoading(false);
                    resolve(coords);
                },
                (err) => {
                    const message = err.message || 'Impossible de récupérer la position';
                    setError(message);
                    setLoading(false);
                    reject(message);
                },
                {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 0
                }
            );
        });
    }, []);

    return { position, error, loading, getLocation };
};

export default useGeolocation;